module.exports = __webpack_public_path__ + "media/images/menu/io-f191624a9cc2ad417db6a703611b6f2f.jpg";